/* eslint-disable react/no-danger */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router'
import { compose } from 'redux'
import {
  REGISTRATION_PENDING,
} from '../../actions/index'
import {transNamespace} from '../../services/conf-utils'
import CONSTANTS from '../../constants/index'
import shevron from '../../../media/back-chevron.svg'
import ErrorPopup from '../error-popup/error-popup'
import LoadingSvg from '../loading-svg'
import withSeparateAuthFlow from '../hoc/separate-auth-flow'

export class EmailSignUp extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      lastName: '',
      email: '',
      password: '',
      passwordError: '',
      passwordRepeat: '',
      passwordRepeatError: '',
      hasNewsletterConsent: false,
      hasTermsConsent: false,
      termsConsentError: '',
      uiPending: false,
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.hasTermsConsent !== prevState.hasTermsConsent) {
      this.consentValidate()
    }
  }

  userNameHandler = (e) => {
    this.setState({
      name: e.target.value,
    })
  }

  userLastNameHandler = (e) => {
    this.setState({
      lastName: e.target.value,
    })
  }

  emailHandler = (e) => {
    this.setState({
      email: e.target.value,
    })
  }

  passwordHandler = (e) => {
    this.setState({
      password: e.target.value,
      passwordError: '',
    })
  }

  passwordRepeatHandler = (e) => {
    this.setState({
      passwordRepeat: e.target.value,
      passwordRepeatError: '',
    })
  }

  newsletterConsentHandler = (e) => {
    this.setState({
      hasNewsletterConsent: e.target.checked,
    })
  }

  termsConsentHandler = (e) => {
    this.setState({
      hasTermsConsent: e.target.checked,
    })
  }

  passwordValidate = () => {
    const { password, passwordRepeat } = this.state
    const { t } = this.props

    if ((password.length < CONSTANTS.AUTH_MIN_PASSWORD_LENGTH) || (password.length > CONSTANTS.AUTH_MAX_PASSWORD_LENGTH)) {
      this.setState({
        passwordError: t('ERROR_PASSWORD_LENGTH'),
        passwordRepeatError: '',
      })
    } else if (password !== passwordRepeat) {
      this.setState({
        passwordError: '',
        passwordRepeatError: t('ACCOUNT_PASSWORDS_VALIDATION'),
      })
    } else {
      this.setState({
        passwordError: '',
        passwordRepeatError: '',
      })
    }
  }

  consentValidate = () => {
    const { t } = this.props

    if (this.state.hasTermsConsent) {
      this.setState({ termsConsentError: '' })
    } else {
      this.setState({ termsConsentError: t('TERM_OF_USE_ERROR') })
    }
  }

  register = (e) => {
    e.preventDefault()

    const { email, name, lastName, password, passwordRepeat, hasTermsConsent, hasNewsletterConsent } = this.state

    this.passwordValidate()
    this.consentValidate()

    if (password !== '' && password === passwordRepeat && hasTermsConsent) {
      this.setState({ uiPending: true })

      this.props.handleAction(REGISTRATION_PENDING, {
        email: email,
        password: password,
        firstName: name,
        lastName: lastName,
        terms: hasTermsConsent,
        newsletter: CONSTANTS.SEPARATE_SUBSCRIPTION ? hasNewsletterConsent : true,
        isRedirectFlow: !!this.props.redirectUri,
      })
    }
  }

  registrationErrorHandler = () => {
    if (this.props.registrationError !== '') {
      return this.props.registrationError
    }

    return ''
  }

  generateLinkMarkup = (url, text) => {
    let markup = ''

    if (url && text) {
      markup = `<a class="xs-text-red cursor-pointer" href="${url}" target="_blank">${text}</a>`
    } else if (!url && text) {
      markup = text
    }

    return markup
  }

  generateSiteLocaleLink = (pageData, locale, key) => {
    const localeFormatted = locale.replace('-', '_')

    if (pageData && pageData.locales && pageData.locales[localeFormatted]) {
      if (pageData.locales[localeFormatted][key]) {
        return pageData.locales[localeFormatted][key]
      }
    } else if (pageData[key]) {
      return pageData[key]
    }

    return false
  }

  render() {
    const { t } = this.props
    const { uiPending } = this.state
    const registrationError = this.registrationErrorHandler()
    const isGdprCompliant = CONSTANTS.SEPARATE_SUBSCRIPTION

    const termsLink = this.generateLinkMarkup(
      this.generateSiteLocaleLink(CONSTANTS.PAGES, CONSTANTS.LOCALE, 'terms_and_conditions'),
      t('TERMS_AND_CONDITIONS'),
    )
    const privacyLink = this.generateLinkMarkup(
      this.generateSiteLocaleLink(CONSTANTS.PAGES, CONSTANTS.LOCALE, 'privacy_policy'),
      t('PRIVACY_POLICY'),
    )

    const termsCopy = isGdprCompliant
      ? t(`${transNamespace()}:TERM_OF_USE`, {terms_and_conditions: termsLink, privacy_policy: privacyLink})
      : t('TERM_OF_USE_WITH_NEWSLETTERS', {terms_and_conditions: termsLink, privacy_policy: privacyLink})

    return (
      <div className="sign-up-page clearfix xs-flex xs-justify-center xs-items-center xs-fill-gray-lighter">

        <div className="xs-flex xs-justify-center xs-fill-gray-lighter xs-relative">

          <form className="centred-content xs-flex xs-flex-column xs-py3 xs-px4 xs-col-12" onSubmit={this.register}>
            <div className="almost-there xs-text-center xs-pb5 xs-relative">
              <Link to="/signup">
                <img alt="back-chevron" src={shevron} className="back-chevron cursor-pointer xs-absolute xs-t2 xs-l0" />
              </Link>
              <div className="xs-text-3 xs-px5">{t('ALMOST_THERE')}</div>
            </div>

            <input
              className="xs-py3 text-input xs-border-bottom-none"
              type="text"
              value={this.state.name}
              onChange={this.userNameHandler}
              placeholder={t('NAME_HOLDER')}
              autoComplete="given-name"
              required
            />

            <input
              className="xs-py3 text-input xs-border-bottom-none"
              type="text"
              value={this.state.lastName}
              onChange={this.userLastNameHandler}
              placeholder={t('LAST_NAME_HOLDER')}
              autoComplete="family-name"
              required
            />

            <input
              className="xs-py3 text-input xs-border-bottom-none"
              type="email"
              value={this.state.email}
              onChange={this.emailHandler}
              placeholder={t('EMAIL_HOLDER')}
              autoComplete="email"
              required
            />

            <input
              className={`xs-py3 text-input xs-border-bottom-none ${this.state.passwordError !== '' && 'error-input'}`}
              type="password"
              value={this.state.password}
              onChange={this.passwordHandler}
              autoComplete="new-password"
              placeholder={t('PASS_HOLDER')}
            />
            { this.state.passwordError !== '' &&
              <span className="error-text">{this.state.passwordError}</span>
            }

            <input
              className={`xs-py3 xs-mb2 text-input ${this.state.passwordRepeatError !== '' && 'error-input'}`}
              type="password"
              value={this.state.passwordRepeat}
              onChange={this.passwordRepeatHandler}
              placeholder={t('REPEAT_PASS_HOLDER')}
              autoComplete="new-password"
              onBlur={this.passwordValidate}
            />
            { this.state.passwordRepeatError !== '' &&
              <span className="error-text">{this.state.passwordRepeatError}</span>
            }

            { isGdprCompliant &&
              <label className="xs-block xs-mb2" htmlFor="newsletter">
                <input type="checkbox" id="newsletter" className="check" defaultChecked={this.state.hasNewsletterConsent} onChange={this.newsletterConsentHandler} />
                <span className="newsletter-consent" dangerouslySetInnerHTML={{__html: t('NEWSLETTER_CONSENT')}} />
              </label>
            }

            <label className="xs-block xs-mb2" htmlFor="terms">
              <input
                type="checkbox"
                id="terms"
                className="check"
                defaultChecked={this.state.hasTermsConsent}
                onChange={this.termsConsentHandler}
              />
              <span className="terms-consent" dangerouslySetInnerHTML={{__html: termsCopy}} />
              { this.state.termsConsentError !== '' &&
                <span className="error-text">{this.state.termsConsentError}</span>
              }
            </label>

            { registrationError &&
              <ErrorPopup t={t} error={registrationError} />
            }

            <button className={`xs-fill-blue-cta rounded xs-border-none cond caps xs-text-white xs-py3 xs-col-12 ${uiPending && !registrationError && 'disabled'}`} type="submit">
              { uiPending && !registrationError
                ? <LoadingSvg />
                : t('BUTTON_EMAIL_SIGN_UP')
              }
            </button>

            <div className="xs-text-center xs-pt5">
              {t('ALREADY_HAVE')}&nbsp;
              <Link to="/signin" className="xs-text-red cursor-pointer">
                {t('CREATE_ACCOUNT_LOG_IN')}
              </Link>
            </div>
          </form>

        </div>

      </div>
    )
  }
}

EmailSignUp.propTypes = {
  t: PropTypes.func.isRequired,
  handleAction: PropTypes.func.isRequired,
  registrationError: PropTypes.string,
  redirectUri: PropTypes.string,
}

EmailSignUp.defaultProps = {
  registrationError: '',
  redirectUri: null,
}

export default compose(
  withSeparateAuthFlow,
)(EmailSignUp)



// WEBPACK FOOTER //
// ./src/components/email-sign-up/email-sign-up.js